/**
 * Signup Form Dropdown Options
 * Centralized constants for user signup data collection
 */

export const USER_TYPES = [
  { value: 'Attorney', label: 'Attorney' },
  { value: 'Investor', label: 'Investor' },
  { value: 'General', label: 'General' }
];

export const USE_CASES = [
  { value: 'Legal', label: 'Legal Services' },
  { value: 'Investment', label: 'Investment & Funding' },
  { value: 'Research', label: 'Research & Analysis' },
  { value: 'Sustainability', label: 'Sustainability Initiatives' },
  { value: 'Other', label: 'Other' }
];

export const REFERRAL_SOURCES = [
  { value: 'Search Engine', label: 'Search Engine (Google, Bing, etc.)' },
  { value: 'Social Media', label: 'Social Media' },
  { value: 'Referral', label: 'Friend or Colleague Referral' },
  { value: 'Conference', label: 'Conference or Event' },
  { value: 'News Article', label: 'News Article or Blog' },
  { value: 'Advertisement', label: 'Advertisement' },
  { value: 'Other', label: 'Other' }
];

export const COUNTRIES = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'AU', label: 'Australia' },
  { value: 'DE', label: 'Germany' },
  { value: 'FR', label: 'France' },
  { value: 'ES', label: 'Spain' },
  { value: 'IT', label: 'Italy' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'SE', label: 'Sweden' },
  { value: 'NO', label: 'Norway' },
  { value: 'DK', label: 'Denmark' },
  { value: 'FI', label: 'Finland' },
  { value: 'IE', label: 'Ireland' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'AT', label: 'Austria' },
  { value: 'BE', label: 'Belgium' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'SG', label: 'Singapore' },
  { value: 'JP', label: 'Japan' },
  { value: 'KR', label: 'South Korea' },
  { value: 'CN', label: 'China' },
  { value: 'IN', label: 'India' },
  { value: 'BR', label: 'Brazil' },
  { value: 'MX', label: 'Mexico' },
  { value: 'AR', label: 'Argentina' },
  { value: 'CL', label: 'Chile' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'IL', label: 'Israel' },
  { value: 'OTHER', label: 'Other' }
];
